module.exports = __webpack_public_path__ + "img/icon_payment_status.5ac2e563.png";